import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const zh_HANT = {
  "home":{
    "bgTitle1":"一個帳戶即可獲得所有Lenovo內容",
    "bgTitle2":"一個帳戶。在一個位置完成全部管理。歡迎使用帳戶儀表板",
    "login":"登錄",
    "register":"創建您的聯想帳戶",
    "help":"幫助",
    "legal":"使用條款",
    "privacy":"隱私聲明",
    "lenovoVip":"聯想會員",
    "lenovoVipText":"聯想為向核心用戶提供更優質的購物體驗，特別推出聯想會員服務，包括註冊送新手禮包、每月優惠券禮包、購物返樂豆、會員價商品、每日延保特權、遊戲特權等11項專屬特權，全方位提升服務體驗。",
    "accountSecurity":"帳戶安全",
    "accountSecurityText":"保護您的Lenovo ID的安全，提供多種方法來保護您的Lenovo ID 和隱私，這些方法包括及時更改密碼，綁定安全手機和郵箱，設置密碼保護等。",
    "singleSign":"單點登錄",
    "singleSignText":"只需要壹個帳戶，就可以暢享多個聯想的服務和應用，還有聯想和合作夥伴提供的專屬或擴展功能。",
    "lenovoHelp":"幫助",
    "lenovoHelpText":"獲得聯想產品和服務方面的專業服務和幫助。",
    "more":"了解更多",
  },
  "help":{
    "Note":"注：如果郵箱收件箱中沒有驗證碼郵件，請檢查垃圾箱中的郵件",
    "accountAppeal":  "帳戶申訴",
    "incorrectEP": "郵箱格式不正確",
    // "incorrectEP": "郵箱格式或手機號格式不正確",
    "appealAccount":  "申訴帳戶:",
    "findAccount": "找回帳戶",
    "submitApplications": '如您帳戶被盜或手機號和郵箱不再使用無法收到驗證碼，請提交申請等待審批。',
    "submitButton": '提交申請',
    "backPrevious": '返回上一頁',
    "back": '返回',
    "nextStep": '下一步',
    "progressQuery": '申請進度查詢',
    "appeal": '發起申訴',
    "contactInfor": '聯系方式',
    "accountInfor": '帳戶資料',
    "completeAppeal":'完成申訴',
    "appealPrompt1": '1、申訴可以找回被盜帳戶，解決無法正常修改密碼保護問題等情況。',
    "appealPrompt2": '2、申訴結果通常會在3個工作日內發送到你留下的郵箱，請註意查收。',
    "businessType": '業務類型:',
    "placeholder1": '郵箱或手機號',
    "gameUsers": '遊戲用戶',
    "enterGrievanceAccount": '請輸入申訴帳戶',
    "enterEmail1": '請輸入郵箱',
    // "incorrectEmail": '郵箱格式或手機號格式不正確',
    "againFill": '此帳戶已提交申訴，請勿重復填寫',
    "contactFill": '填寫接收申訴結果的聯系方式',
    "contactDetails": '聯系方式:',
    "ContactEmail": '聯系郵箱:',
    "appealResult": '此郵箱用于接收申訴結果',
    "code": '驗證碼:',
    "basicAccountInfor": '帳戶基本信息',
    "usedEmail": '曾用郵箱:',
    "usedphone": '曾用手機:',
    "registrationTime": '注冊時間:',
    "name": '真實姓名:',
    "idNumber": '證件號碼:',
    "idPhoto": '證件照片:',
    "enterUsedEmail": '請填寫您曾綁定過的郵箱',
    "enterUsedphone": '請填寫您曾綁定過的手機號',
    "enterRegistrationTime": '請填寫您帳戶的注冊時間',
    "chineseName": '請輸入您的中文真實姓名',
    "idName": '請輸入18位身份證號',
    "upload": '点击上传',
    "uploadPhotos": '請分別上傳身份證正反面照片',
    "imageExceed": '1.每張圖片的大小不能超過2MB（2MB=2048KB）',
    "imageExceed2": '2.必須提供至少3筆訂單截圖，且包含遊戲首筆及被盜前最後一筆支付訂單，若累計充值不到3筆需提供全部消費訂單，所提供的消費訂單截圖必須能看清商家訂單號及支付時間',
    "imageExceed3": '3.沒有遊戲內充值的帳戶需要提供帳戶最開始註冊時的驗證碼截圖或者對應手機號的營業廳截圖',
    "onlyUsed": '2.證件圖片僅用于帳戶申訴時核實身份，絕無其他用途',
    "noId": '3.若無身份證，也可提供戶口簿、護照、軍官證、士兵證、港澳臺通行證圖片；',
    "accountUseInfor": '帳戶使用信息',
    "gameName": '遊戲名稱:',
    "gameName1": '遊戲名稱',
    "gameService": '遊戲區服:',
    "gameService1": '遊戲區服',
    "gameNicknames": '遊戲內昵稱:',
    "gameNicknames1": '遊戲內昵稱',
    "gameID": '遊戲ID:',
    "gameID1": '遊戲ID',
    "Gamename3": '所玩遊戲名稱',
    "rechargeOrder": '充值訂單:',
    "otherInfor": '其他信息:',
    "service": "聯繫方式:",
    "cService": "客服QQ: 3007422129",
    "oService": "在線客服",
    "deliveryAddress": '收貨地址:',
    "addressUsed": '請填寫曾使用過的收貨地址',
    "consumptionInfor": '消費信息:',
    "enterConsumptionInfor": '請填寫您的消費信息',
    "douInfor": '樂豆信息:',
    "enterDouInfor": '請填寫樂豆數量',
    "orderNo": '訂單編號:',
    "enterOrderNo": '請輸入訂單編號',
    "addInfor": '補充信息:',
    "backupData": '備份數據類型:',
    "photoContact": '照片或聯系人信息',
    "lastTime": '最後一次使用時間:',
    "enterLastTime": '請填寫最後一次使用應用時間',
    "complaintAccepted": '申訴已受理',
    "photosBacked": '雲服務中備份的照片:',
    "Previous": '返回',
    "receiveEmail": '通過郵箱接收申訴結果',
    "enterEmail": '請輸入您常用的郵箱',
    "enterCode": '填寫驗證碼',
    "required": '*號為必填項',
    "workingDay": '申訴結果將在3個工作日內發送到您填寫的聯繫郵箱',
    "workingDay7": '請勿重複提交帳戶申訴，如您申訴的帳戶存在多人同時申訴的情況，我們將在7個工作日內通知您申訴結果。',
    "done": '完成',
    "errEmail": '聯繫郵箱格式錯誤',
    "enterName": '請輸入姓名',
    "incorrectEmail1": '郵箱格式不正確',
    "incorrectPhone": '手機號格式不正確',
    "enterNumber": '請輸入證件號碼',
    "idNumber18": '請輸入18位證件號碼',
    "enterGameName": '請輸入遊戲名稱',
    "enterInGameName": '請輸入遊戲內名稱',
    "enterZService": '請輸入區服',
    "enterGameID": '請輸入遊戲ID',
    "onlyJpg": '上傳文件格式僅支持jpg、png和jpeg!',
    "imageSize": '上傳圖片大小不能超過 2MB!',
    "twoImage": '上傳圖片不能超過2張!',
    "FileImage": '上傳圖片不能超過5張!',
    "errorImage": '上傳圖片失敗!',
    "errorImage1": '上傳圖片名稱字數超過限制!',
    "uploadId": '請上傳您的證件',
    "uploadOrder": '請上傳您的訂單資訊',
    "sure": '確定',
    "getCode": '獲取驗證碼',
    "enterCode": '請輸入驗證碼',
    "codeError": '驗證碼錯誤',
    "invalidCode": '驗證碼已失效',
    "upperLimit": '驗證碼發送次數已達上限',
    "emailNoAgain": '此郵箱已提交申訴，請勿重複填寫',
    "phoneNoAgain": '此帳戶已提交申訴，請勿重複填寫',
  },
  "appeal": {
   "idResult": '聯想帳戶申訴結果',
   "bindInfor": '請輸入您需要綁定的信息',
   "SetPassword": '請設置您的登錄密碼',
   "successfulAppeal": '申訴成功,授權與驗證',
    "chooseEmailP": '請選擇您需要重置的安全信息',
    "securityInfor": '重置安全信息',
    "passAccount": '恭喜您通過帳戶申訴審核',
    "checkCode": '申訴系統已將授權碼發送至您的聯系郵箱中，請到您的聯系郵箱中查收您的授權碼',
    "recivedCode": '收到的授權碼:',
    "enterAuthoriCode": '請輸入授權碼',
    "secureEmail": '重置安全郵箱',
    "changeInfor": '重置後可以使用此郵箱登錄，並作爲更改安全信息的身份驗證方式。',
    "reset": '重置',
    "resetPhone": '重置安全手機',
    "changePhone": '重置後可以使用此手機號登錄，並作爲更改安全信息的身份驗證方式。',
    "resetPassword": '重置密碼',
    "completeSet": '完成設置',
    "enterGraphicCode": '輸入圖形驗證碼',
    "sentToEmail": '請輸入上面顯示的字符，然後單擊下面的按鈕。驗證碼將發送至您的郵箱',
    "getVCode": '獲取郵箱驗證碼',
    "resend": '重新發送',
    "enterEmailVerCode": '輸入郵箱驗證碼  ',
    "pEnterGraphicCode": '請輸入圖形驗證碼 ',
    "pEnterGraphicCode1": '請輸入圖形驗證碼 ',
    "requestAgain": '請求次數過多，請稍後重試  ',
    "verificationCodeError": '圖形驗證碼錯誤',
    "verificationCodeError1": '圖形驗證碼錯誤',
    "enterNewPassword": '輸入新密碼',
    "surePassword": '確認密碼',
    "password8": '密碼必須至少包含8-20個英文字符，並且至少包含以下三種:大寫字母、小寫字母、數字和符號。',
    "emptyCode": '密碼不可為空',
    "twoInconsistencies": '兩次輸入不一致 ',
    "passwordNotRules": '密碼不符合規則  ',
    "requestLocked": '請求被鎖定',
    "newExists": '新用戶已存在 ',
    "codeFrozen": '帳戶已被凍結',
    "vCodeError": '郵箱驗證碼錯誤',
    "cheackOk": '請查看所輸入的信息是否正確',
    "enterAuthoriCode1": '您已超時，請重新訪問重置鏈接輸入授權碼',
    "accountNotExist": '帳戶不存在',
    "emailSetUp": '您的安全郵箱已經設置完成',
    "returnHome": '秒後將自動返回首頁',
    "accountSet": '您可以進行與帳戶安全相關的設置',
    "enterPhoneCode": '請輸入手機號',
    "SentToPhone": '請輸入上面顯示的字符，然後單擊下面的按鈕。 驗證碼將發送至您的手機',
    "SMSCode": '請輸入簡訊驗證碼 ',
    "authorizationError": '授權碼錯誤',
    "ACodeExpired": '授權碼過期',
    "enterNewPassword": '輸入新密碼',
    "SmSError": '短訊動態碼錯誤',
    "phoneSetUp": '您的安全手機已經設置完成',
    "linkExpired": '鏈接已過期，請重新填寫申訴表單',
    "note1": '注：所綁定的手機號或郵箱必須真實有效並且沒有注冊過LenovoID'
  },
  "freezing":{
    "AccountEnable": '帳戶解凍',
    "confirmInfor": '請確認帳戶信息',
    "accountDisabled": '帳戶凍結',
    "successActiviva": '解凍成功',
    "disableSuccess": '凍結成功',
    "currentDisabled": '當前帳戶已被凍結，請確認是否解凍',
    "UID": 'UID(聯想帳戶唯一標識) :',
    "currentName": '當前帳戶用戶名 :',
    "note": '注：凍結該帳戶後，用戶將無法進行任何操作',
    "no": '否',
    "yes": '是',
    "linkExpired": '此鏈接無效，無法進行操作',
  },
  "security":{
    "linkSecurity": '生成重置安全信息鏈接:',
    "linkAccount": '生成帳戶凍結/解凍鏈接:',
    "UserId": '請輸入UserID',
    "submit": '提交',
    "optionNempty": '選項不能為空',
    "resetSecurity": '申請重置安全信息',
    "applyInformation": '請填寫以下信息並申請',
    "applyAccepted": '申請已受理',
    "userEmail": '請在工單系統中查看詳細內容，並將重置安全信息鏈接發送至用戶的聯系郵箱。 ',
    "userIDInvalid": 'UserID無效',
    "notSubmit": '此帳戶未提交申訴',
    "notMatch": '聯系郵箱與申訴帳戶不匹配',
    "access": '您無權訪問此頁面',
  },
  ...enLocale
}

export default zh_HANT



// WEBPACK FOOTER //
// ./src/i18n/language/zh_HANT.js